/**
 * @file piecesEnums.ts
 * @description Ce fichier contient les définitions des constantes et types pour les types de documents et les statuts de documents.
 */

export const PieceType = {
  /**
   * @description Facture d'achat.
   */
  ACHAT: "Facture d'achat",

  /**
   * @description Facture de vente.
   */
  VENTE: 'Facture de vente',

  /**
   * @description Notes de frais.
   */
  FRAIS: 'Notes de frais',

  /**
   * @description Autres types de documents.
   */
  AUTRES: 'Autres',
} as const;

/**
 * @typedef PieceType
 * @description Type représentant les différents types de documents.
 */
export type PieceType = keyof typeof PieceType;

export const PieceStatus = {
  RECEPTIONNE: 'Réceptionné',
  EN_TRAITEMENT: 'En traitement',
  COMPTABILISE: 'Comptabilisé',
  A_VALIDER: 'À valider',
  EN_ANOMALIE: 'En anomalie',
  DOUBLON: 'Doublon',
  SUPPRIME: 'Supprimé',
} as const;

/**
 * @typedef PieceStatus
 * @description Type représentant les statuts des documents.
 */
export type PieceStatus = keyof typeof PieceStatus;

export const TransactionType = {
  CREDIT: 'Credit',
  DEBIT: 'Debit',
} as const;

/**
 * @typedef PieceStatus
 * @description Type représentant les statuts des documents.
 */
export type TransactionType = keyof typeof TransactionType;

export const TypeMenu = {
  SAVE_AND_CLOSE: 'save and close only',
  SAVE_AND_NEXT: 'save and close and save and next',
} as const;
/**
 * @typedef TypeMenu
 * @description Type représentant les types de menu.
 */
export type TypeMenu = keyof typeof TypeMenu;
